import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  Collapse,
  Container,
  Navbar,
  NavbarToggler,
  NavItem,
  NavLink,
} from "reactstrap";
import { signOut } from "../oidcUtilities";
import { ApplicationState } from "../store";
import { Simulators } from "../store/WorkspaceStore/models";
import { LegacyServerUrl } from "./Legacy/ServerUrl";
import { withRedux } from "./Legacy/hoc";
import "./NavMenu.css";
import SimulatorDropdown from "./SimulatorDropdown";
import UWG5NventServerUrl from "./UWG5Nvent/ServerUrl";
import WorkspaceDropdown from "./Workspace/WorkspaceDropdown";

const LegacyServerUrlNuHeat = withRedux(LegacyServerUrl, Simulators.NuHeat);

const NavMenu = (props: ApplicationState) => {
  // Component state
  const [isOpen, setIsOpen] = React.useState(false);

  const getNavBarBackground = (simulator: Simulators) => {
    switch (simulator) {
      case Simulators.NuHeat:
        return "bg-nuheat";
      case Simulators.UWG5Nvent:
        return "bg-uwg5nvent";
      default:
        return "bg-dark";
    }
  };

  // Render
  return (
    <header>
      <Navbar
        className={
          getNavBarBackground(props.workspace.simulator) +
          " navbar-expand-sm navbar-dark navbar-toggleable-sm border-bottom box-shadow mb-3"
        }
        light
      >
        <Container>
          <SimulatorDropdown />
          <WorkspaceDropdown />
          <NavbarToggler onClick={() => setIsOpen(!isOpen)} className="mr-2" />
          <Collapse
            className="d-sm-inline-flex flex-sm-row-reverse"
            isOpen={isOpen}
            navbar
          >
            <ul className="navbar-nav flex-grow">
              <NavItem>
                <NavLink className="text-white" tag={Link} to="/">
                  Home
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className="text-white"
                  tag={Link}
                  to={{
                    pathname:
                      "/wizard/" + Simulators[props.workspace.simulator],
                  }}
                >
                  Create Wizard
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className="text-white"
                  tag={Link}
                  to={{
                    pathname: "/load/" + Simulators[props.workspace.simulator],
                  }}
                >
                  Load Wizard
                </NavLink>
              </NavItem>
              <NavItem>
                {props.workspace.simulator === Simulators.UWG5Nvent && (
                  <UWG5NventServerUrl />
                )}
                {props.workspace.simulator !== Simulators.UWG5Nvent && (
                  <Link
                    to="#"
                    component={LegacyServerUrlNuHeat}
                  />
                )}
              </NavItem>
              <NavItem>
                <NavLink
                  to="#"
                  tag={Link}
                  className="text-white"
                  onClick={(e) => {
                    e.preventDefault();
                    signOut();
                  }}
                  title="Logout"
                >
                  Logout
                </NavLink>
              </NavItem>
            </ul>
          </Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default connect((state: ApplicationState) => state)(NavMenu as any);
